/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// @mui material components
import Icon from '@mui/material/Icon';
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDButton from 'components/MDButton';

function BranchUpload({ uploadData }) {
  const { t } = useTranslation();
  const fileInput = createRef();

  const handleImageChange = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      uploadData(reader.result, file);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <input
            ref={fileInput}
            accept='.png, .jpg'
            style={{ display: 'none' }}
            type='file'
            onChange={handleImageChange}
          />
          <label htmlFor='file-open'>
            <MDButton
              variant='gradient'
              color='info'
              size='small'
              component='span'
              onClick={() => handleClick()}
            >
              <Icon>image</Icon>&nbsp;{t('upload.browse')}
            </MDButton>
          </label>
        </Grid>
      </Grid>
    </div>
  );
}

BranchUpload.propTypes = {
  uploadData: PropTypes.func.isRequired,
};

export default BranchUpload;
